import {
    WITHDRAWEMONEYLIST_SUCCESS,
    WITHDRAWEMONEYLIST_FAILED,
    RESET_WITHDRAWEMONEYLIST,
    LOADING_WITHDRAWEMONEYLIST,
    WITHDRAWEMONEYLIST_NETWORKERROR,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_WITHDRAWEMONEYLIST:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case WITHDRAWEMONEYLIST_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case WITHDRAWEMONEYLIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case WITHDRAWEMONEYLIST_NETWORKERROR:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_WITHDRAWEMONEYLIST:
            return (state = initialState);
        default:
            return state;
    }
};
